import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
    isAuthenticated: boolean
    token: string | null
    user: User | null
    login: (token: string, user: User) => void
    logout: () => void
    checkAuth: () => void
}

export default interface User {
    id?: string
    roleId?: string
    fullName: string
    email: string
    avatar?: string
    countryCode: string
    phone: string
    password: string
    salt: string
    lastLogin?: Date
    firstTime?: boolean
    verificationCode?: string
    statusId?: string
    role?: any
    status?: any
    addresses?: any[]
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            isAuthenticated: false,
            token: null,
            user: null,

            login: (token: string, user: User) => {
                set({
                    isAuthenticated: true,
                    token,
                    user
                })
            },

            logout: () => {
                set({
                    isAuthenticated: false,
                    token: null,
                    user: null
                })
            },

            checkAuth: () => {
                const token = get().token
                const user = get().user

                if (token && user) {
                    set({ isAuthenticated: true })
                } else {
                    set({ isAuthenticated: false })
                }
            }
        }),
        {
            name: 'auth-storage',
            partialize: (state) => ({ token: state.token, user: state.user, isAuthenticated: state.isAuthenticated })
        }
    )
)
